import styled from "@emotion/styled";

// Typography primitives shared by every tutorial article. Colours mirror the
// InProgress / Uploads pages (panel rgba(41,56,77), text #F7FAFA at reduced
// opacity, accent #F5C754) so articles read as part of the dashboard.

export const ArticleBody = styled.article`
  color: rgba(247, 250, 250, 0.86);
  font-size: 15px;
  line-height: 1.6;
  max-width: 760px;

  h3 {
    margin: 22px 0 8px;
    font-size: 17px;
    font-weight: 700;
    color: #f7fafa;
  }

  h3:first-of-type {
    margin-top: 4px;
  }

  p {
    margin: 0 0 12px;
  }

  ul,
  ol {
    margin: 0 0 12px;
    padding-left: 22px;
  }

  li {
    margin-bottom: 6px;
  }

  strong {
    color: #f5c754;
    font-weight: 700;
  }

  code {
    font-size: 13px;
    padding: 1px 6px;
    border-radius: 6px;
    background: rgba(255, 255, 255, 0.08);
    color: #f7fafa;
  }
`;

export const ArticleCallout = styled.div`
  margin: 14px 0 18px;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid ${({ tone }) => (tone === "warning" ? "rgba(255,176,46,0.55)" : "rgba(139,148,255,0.35)")};
  background: ${({ tone }) => (tone === "warning" ? "rgba(255,176,46,0.10)" : "rgba(99,102,199,0.16)")};
  color: rgba(247, 250, 250, 0.92);
  font-size: 14px;
`;

export const ArticleTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 8px 0 18px;
  font-size: 14px;

  th,
  td {
    text-align: left;
    vertical-align: top;
    padding: 8px 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  th {
    font-size: 11px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: rgba(247, 250, 250, 0.6);
    font-weight: 700;
  }

  td:first-of-type {
    font-weight: 600;
    color: #f7fafa;
    min-width: 140px;
  }
`;

export const ArticleTableWrap = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const ArticleDemoFrame = styled.div`
  margin: 10px 0 18px;
  padding: 14px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(41, 56, 77, 0.55);
  max-width: 560px;
`;
